'use strict';

var giftCard = require('./gift-card/main');
var video = require('./video/main');
var images = require('./images/main');
var product = require('./product/main');
var service = require('./service/main');
var scheduler = require('./scheduler/main');
var pinboard = require('./pinboard');
var loadMore = require('./load-more');
var infiniteCarousel = require('./infinite-carousel');

var blocks = {
	giftCard: giftCard,
	video: video,
	images: images,
	product: product,
	service: service,
	scheduler: scheduler,
	pinboard: pinboard,
	loadMore: loadMore,
	infinitecarousel: infiniteCarousel
};

var init = function() {

	// Possibly init all blocks here, refactor as necessary (need to see how much js is actually needed for the blocks)
	Object.keys(blocks).forEach(function(block) {

		blocks[block].init();

	});

};

module.exports = {
	init: init
};
